

import {Component, Vue} from "vue-property-decorator";
import {DBService} from "@/components/Database/DBService";
import HomeNews from "@/components/HomeNews.vue";

@Component({
  components: {HomeNews}
})
export default class Home extends Vue {
  slides: any[] = [];
  language: string | null = localStorage.getItem("lang");

  constructor() {
    super();
    this.getSlideShowFromDB()
    this.language = localStorage.getItem("lang")
  }

  async getSlideShowFromDB() {
    const slides = (await DBService.getInstance().getSlideShow());
    if (slides) {
      this.slides = slides;
    }
  }

  created() {
    if (localStorage.getItem("lang") === null)
      localStorage.setItem("lang", 'de')
  }
}
